<template>
  <div id="app">
    <DownloadHint />
    <nonetup/>
    <!-- <nonet/> -->

    <div class="headNav"></div>

    <keep-alive include="CreateProduct,Search,home,index" exclude="index,my">
      <!-- <navigation> -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!-- </navigation> -->
    </keep-alive>

    <router-view v-if="$route.meta.keepAlive"></router-view>

    <transition appear>
      <router-view name="intoBooth"></router-view>
    </transition>
    <!--  <baidu-map  :zoom="zoom" @ready="handlerMap" style="display: none;">
      </baidu-map> -->
    <!-- <HomePop></HomePop> -->
    <!-- <booth></booth> -->

    <!-- <div class="overlay">
      <van-overlay :show="this.$store.state.passwordStatus" :lock-scroll="true">
        <div class="wrapper" @click.stop>
          <div class="block">
            <p class="title">输入密码</p>
            <p class="ipt">
              <input
                type="password"
                v-model="password"
                placeholder="请输入密码"
              />
            </p>
            <div class="confirm" @click="confirm"><p>确认</p></div>
            <div class="cancel" @click="cancel">取消</div>
          </div>
        </div>
      </van-overlay>
    </div> -->
  </div>
</template>

<script>
import indexedDB from './indexedDB'
import Nonetup from './pages/nonet/nonetup.vue'
// import Nonet from "./pages/nonet/nonet.vue";
import CreateProduct from './pages/my/CreateProduct.vue'
// import HomePop from "./components/HomePop";
// import Booth from './pages/home/Booth.vue';
import api from './utils/api'
import {aGet, aPost, upImg2} from './utils/request'
import nfc from './utils/nfc'
import {mapActions} from 'vuex'
import {Dialog} from "vant";
import DownloadHint from './components/DownloadHint.vue';

export default {
  name: 'App',

  components: {
    DownloadHint,
    Nonetup,
    // Nonet,
    CreateProduct
    // HomePop,
    // Booth
  },

  data() {
    return {
      zoom: 15,
      password: null,
      version: '',
      network: true, //默认有网
      msg: 'no mess',
      message: [],
      unifo: []
    }
  },
  watch: {
    '$store.getters.nfcReadtxt': {
      handler(newVal, oldVal) {
        // 当 `$store.getters.nfcreadtxt` 发生变化时，执行下一步方法
        this.readNextStep(newVal)
      }
      // immediate: true // 立即执行一次，以处理初始值
    },
    '$store.getters.nfcWriteTxt': {
      handler(newVal, oldVal) {
        // 当 `$store.getters.nfcreadtxt` 发生变化时，执行下一步方法
        this.writeNextStep(newVal)
      }
      // immediate: true // 立即执行一次，以处理初始值
    }
  },


  created() {
    indexedDB.dbstar()
    if (navigator.onLine) {
      console.log('在线')
    } else {
      console.log('离线')
    }

  },
  onLoad() {
  },
  methods: {
    ...mapActions(['setWriteState']),


    // 初始化微信SDK
    async initWeChatSDK() {
      // 判断是否为微信浏览器
      const isWeChatBrowser = /MicroMessenger/i.test(window.navigator.userAgent);
      if (!isWeChatBrowser) {
        console.log('当前不是微信浏览器，跳过微信SDK初始化');
        return;
      }

      console.log('初始化微信SDK');

      // 获取微信分享配置
      try {
        const config = await this.getWxMPConfig();
        console.log('微信配置获取成功：', config);

        wx.config({
          debug: false, // 设置为 false 可以关闭调试
          appId: config.appId, // 必填，公众号的唯一标识
          timestamp: config.timestamp, // 必填，生成签名的时间戳
          nonceStr: config.nonceStr, // 必填，生成签名的随机串
          signature: config.signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'
          ], // 必填，需要使用的 JS 接口列表
          openTagList: ['wx-open-launch-weapp']
        });

        wx.ready(() => {
          console.log('---App vue ready')
          //this.setupWeChatShare();
        });

        wx.ready(() => {
          //this.setupWeChatShareOrigin();
        });

        wx.error((res) => {
          console.error('-------------微信SDK配置失败：', res);
          alert(`------------微信配置错误：${res.errMsg}`); // 错误提示
        });

      } catch (error) {
        console.error('--------------获取微信配置失败：', error);
      }
    },
    // 获取微信配置
    async getWxMPConfig() {
      // 获取当前页面的 URL，去掉 # 及其后面的部分
      const url = location.href.split('#')[0];
      //const url = encodeURIComponent(location.href.split('#')[0] + location.href.split('#/')[1]);

      console.log('url--------: ', url)

      try {
        const res = await aPost(api.getWxConfig, { url });
        const data = res.data.map;
        console.log('--------------微信分享配置:', data);
        return data;
      } catch (err) {
        console.error('获-----------取微信分享配置失败:', err);
        throw new Error('获-----------取微信配置失败');
      }
    },

    getLinkParams(link) {
      let queryParams = '';

      // 判断 URL 是否包含查询参数或哈希
      if (!link.includes('?') && !link.includes('#')) {
        console.error('Invalid link format, missing query parameters.');
        return null; // 返回 null 表示解析失败
      }

      // 处理相对路径（例如 /salesDetails）
      if (link.startsWith('/')) {
        // 获取 ? 后面的部分作为查询参数
        queryParams = link.split('?')[1]; // 提取查询参数
      } else if (link.startsWith('http://') || link.startsWith('https://')) {
        // 处理 http 或 https 协议开头的链接
        if (link.includes('#')) {
          // 如果 URL 包含 hash 部分
          const hashPart = link.split('#')[1]; // 获取 # 后面的部分
          queryParams = hashPart.split('?')[1]; // 获取 ? 后面的查询参数
        } else if (link.includes('?')) {
          queryParams = link.split('?')[1]; // 直接从 ? 开始的部分获取查询参数
        }
      } else if (link.startsWith('tatashi://')) {
        // 处理 tatashi 协议的链接
        const tatashiPart = link.split('tatashi://')[1]; // 获取 tatashi:// 后面的部分
        queryParams = tatashiPart.split('?')[1]; // 获取 ? 后面的查询参数
      }

      if (!queryParams) {
        console.error('No query parameters found in link.');
        return null;
      }

      return new URLSearchParams(queryParams); // 返回 URLSearchParams 对象
    },
    async readNextStep(link) {
      console.log('====读取 link:', JSON.stringify(link));

      // 使用 getLinkParams 获取参数
      const params = this.getLinkParams(link);

      // 获取 id 和 chipUid
      const productId = params.get('id');  // 假设 id 是产品 ID
      const chipUid = params.get('chipUid'); // 假设 chipUid 是芯片 ID
      const code = params.get('code') || 0; // 假设 code 是写入芯片的 code
      const chipCode = params.get('chipCode') || 0;
      const storeId = params.get('storeId') || 0;
      const shelfId = params.get('shelfId') || 0;
      let query ={storeId, shelfId}

      // 检查是否成功解析出 chipUid
      if (!chipUid) {
        console.error('无法解析 chipUid');
        return;
      }

      if (productId > 0) {
        const userGeo = await this.$geoLocation.fetchCurrentGeo();
        this.$store.commit('setUserGeo', userGeo)
        console.log('获取用户最新地理信息:', JSON.stringify(userGeo));
        //console.log('Parsed productId:', JSON.stringify(productId));
        //console.log('Parsed chipUid:', JSON.stringify(chipUid));

        // 获取 Vuex store 中的 userGeo 并添加其他参数
        let param = {...this.$store.state.userGeo}; // 拷贝一份防止直接修改 state
        param.productId = productId;
        param.chipUid = chipUid;
        param.operateType = 0; // 表示读取操作
        param.code = code //芯片绑定的code
        param.chipCode = chipCode
        param.platform = 'app'

        // 保存用户地址和芯片码关联
        aPost(api.saveUserAddressReadChipLocaltionList, param)
          .then((res) => {
            console.log('用户地址和芯片码读取记录上传成功:', JSON.stringify(param), JSON.stringify(res.data));
          })
          .catch((error) => {
            console.error('用户地址和芯片码读取记录上传失败:', JSON.stringify(param), JSON.stringify(error));
          });
      }



      // 路由跳转逻辑
      const currentPath = this.$route.path;
      const currentQuery = this.$route.query;

      const [linkPath, linkQueryString] = link.split('?');
      const linkQuery = linkQueryString ? Object.fromEntries(new URLSearchParams(linkQueryString)) : {};

      console.log("=====currentPath ", currentPath, "=====linkPath", linkPath)

      if (currentPath === linkPath) {
        console.log('======路径相同,替换:', link, JSON.stringify(query));
        this.$router.push({
          path: link,
          query: {
            ...query,
            forceRefresh: Date.now(), // 添加一个动态参数，确保路由变化
          },
        });
      } else {
        console.log('======路径不同，使用 push 跳转:', link, JSON.stringify(query));
        this.$router.push({
          path: link,
          query: query,
        });
      }

      // 重新启用 NFC 读取功能
      nfc.enableReadData();
    },
    async writeNextStep(link) {
      console.log('===写入的连接: ', JSON.stringify(link));

      // 使用 getLinkParams 函数解析 URL 参数
      const params = this.getLinkParams(link);

      if (!params) {
        console.error('无法解析 URL 参数, 不上传扫码记录');
        nfc.enableReadData();
        return;
      }

      const productId = params.get('id'); // 假设 URL 参数名为 id
      const chipUid = params.get('chipUid'); // 假设 URL 参数名为 chipUid
      const code = params.get('code') || 0; // 假设 code 是写入芯片的 code
      const chipCode = params.get('chipCode') || 0;

      if (!productId || !chipUid) {
        console.error('无法解析 productId 或 chipUid, 不上传扫码记录');
        nfc.enableReadData();
        return;
      }

      const userGeo = await this.$geoLocation.fetchCurrentGeo();
      this.$store.commit('setUserGeo', userGeo)
      console.log('获取用户最新地理信息:', JSON.stringify(userGeo));
      console.log('Parsed productId:', JSON.stringify(productId));
      console.log('Parsed chipUid:', JSON.stringify(chipUid));

      // 获取 Vuex store 中的 userGeo 并添加其他参数
      let param = {...this.$store.state.userGeo}; // 使用拷贝防止修改 state
      param.productId = productId;
      param.chipUid = chipUid;
      param.operateType = 1; // 表示写入操作
      param.code = code
      param.platform = 'app'
      param.chipCode = chipCode

      // 上传芯片写入记录
      /*
      aPost(api.chipWrite, param)
        .then((res) => {
          console.log('芯片码写入记录上传成功:', JSON.stringify(res.data));
        })
        .catch((error) => {
          console.error('芯片码写入记录上传失败:', JSON.stringify(error));
        });
      */

      // 保存用户地址和芯片码关联
      aPost(api.saveUserAddressReadChipLocaltionList, param)
        .then((res) => {
          console.log('用户地址和芯片码写入记录上传成功:', JSON.stringify(param), JSON.stringify(res.data));
        })
        .catch((error) => {
          console.error('用户地址和芯片码写入记录上传失败:', JSON.stringify(param), JSON.stringify(error));
        });

      // 重新启用 NFC 读取功能
      await nfc.enableReadData();
    },


    confirm() {
      if (navigator.onLine) {
        let parma = {
          password: this.password,
          userId: JSON.parse(localStorage.getItem('id'))
        }

        aPost(api.checkPassword, parma).then((res) => {
          if (res.data.code == 0) {
            this.$store.commit('SET_PASSWORD_STATUS', false)
            this.show = false
            this.password = ''
          } else {
            this.password = ''
            this.$toast('密码错误，请重试！')
            // this.$router.back()
          }
        })
      } else {
        if (this.password == localStorage.getItem('psw')) {
          this.$store.commit('SET_PASSWORD_STATUS', false)
          this.show = false
          this.password = ''
        } else {
          this.password = ''
          this.$toast('密码错误，请重试！')
        }
      }
    },

    cancel() {
      this.show = false
      this.$store.commit('SET_PASSWORD_STATUS', false)
      this.$router.push('/')
    },
    // 更新应用资源
    installWgt(path) {
      let that = this
      plus.nativeUI.closeWaiting()
      plus.nativeUI.showWaiting('下载安装最新文件中,请稍候...')
      plus.runtime.install(
        path,
        {},
        function () {
          plus.nativeUI.closeWaiting()
          plus.nativeUI.alert('应用资源更新完成！', function () {
            plus.runtime.restart()
          })
        },
        function (e) {
          plus.nativeUI.closeWaiting()
          plus.nativeUI.alert('安装更新文件失败[' + e.code + ']：' + e.message)
        }
      )
    },
    downWgt(wgtUrl) {
      var that = this
      plus.nativeUI.alert('下载更新文件...')
      plus.downloader
        .createDownload(
          wgtUrl,
          {
            filename: '_doc/update/'
          },
          function (d, status) {
            console.log('status: ' + status)
            if (status == 200) {
              console.log('下载wgt成功：' + d.filename)
              that.installWgt(d.filename) // 安装wgt包
            } else {
              //console.log("下载wgt失败！");
              plus.nativeUI.closeWaiting()
              plus.nativeUI.alert('下载更新失败！')
            }
            plus.nativeUI.closeWaiting()
          }
        )
        .start()
    },
    versionRecordList() {
      var that = this
      aPost(api.getVersion).then((res) => {
        console.log('版本', JSON.stringify(res))
        console.log('versionRecordList: 当前版本:', this.version + ',新版本:', res.data.data.versionCode)
        //版本号目前是4位数 将版本号带小数点的转化为正整数
        var currentVersion = that.getInt(this.version)   //当前版本
        var newVersion = that.getInt(res.data.data.versionCode)       //新版本
        console.log('versionRecordList: 转化为正整数后 当前版本:', currentVersion + ',新版本:', newVersion)
        if (currentVersion < newVersion) {    //当前版本小于新版本时才升级
          console.log('有新版本,升级中...')
          //可以升级
          plus.nativeUI.confirm(
            '检查到当前版本有最新更新，下载升级？',
            function (event) {
              if (event.index == 0) {
                console.log('下载地址：' + res.data.data.downloadUrl)
                that.downWgt(res.data.data.downloadUrl) //下载更新版的地址
              }
            },
            '系统消息',
            ['马上升级', '下次再说']
          )
        }
      })
    },
    //将小数点转为正整数
    getInt(number) {
      var int = 0;
      //将小数点去除
      int = parseInt(number.replace(/\./g, ''))
      console.log('int:', int)
      return int
    },
    async handleBackButton() {
      console.log("=============当前 PATH:", this.$route.path)

      let storeId = localStorage.getItem("viewStoreId")
      if(this.$route.path === '/salesDetails') {
        console.log("=====返回商品列表")
        this.$router.replace({ path: '/AdvertisingBooth', query: { storeId: storeId } })
        return
      }

      if(this.$route.path === '/AdvertisingBooth') {
        this.$router.push({ path: '/', query: { id: storeId } })
        return
      }

      if (this.$route.path === '/') {
        plus.nativeUI.confirm('是否退出应用？', (event) => {
          if (event.index === 0) {
            // 用户确认退出
            plus.runtime.quit();
          }
        }, '退出应用', ['确定', '取消']);
      } else {
        console.log("------------路由后退一步")
        //history.back()
        let writeModePaths = ["/shelf/manager", "/WriteChip"]
        //如果不包含
        if (writeModePaths.indexOf(this.$route.path) !== -1) {
          console.log("--------NFC 强制转换为读取模式", this.$route.path)
          nfc.forceReadDataMode()
        }
        this.$router.go(-1)
        //this.$router.back()
        // this.$router.go(-1)
      }
    },
  },
  destroyed() {
    window.removeEventListener('popstate', this.backChange, false);
    if (window.plus) {
      plus.key.removeEventListener('backbutton', this.handleBackButton, false);
    }
  },
  async mounted() {
    this.initWeChatSDK()
    let that = this

    document.addEventListener('plusready', function () {
      plus.runtime.getProperty(plus.runtime.appid, function (inf) {
        // console.log("inf", inf);
        console.log('inf', JSON.stringify(inf))
        that.version = inf.version
      })
      //获取版本
      if (navigator.onLine) {
        console.log('当前在线,准备检查升级...')
        that.versionRecordList()
      }
      checkArguments()
      console.log('--------------开启监听NFC消息')
      nfc.listenNFCStatus()
    })
    // 判断启动方式
    function checkArguments() {
      console.log('plus.runtime.launcher: ' + plus.runtime.launcher)
      //that.$router.push(url)

      // 取到参数值后，直接赋值清空，有些情况下，单独一个赋值并不能清空，请直接使用下面两条语句。
      plus.runtime.arguments = null;
      plus.runtime.arguments = "";
    }

    window.addEventListener('popstate', this.backChange, false);

    document.addEventListener('plusready', () => {
      plus.key.addEventListener('backbutton', this.handleBackButton, false);
    });


  }
}
</script>
<style scoped lang="scss">
html,
body {
  height: 100%;
}

#app {
  height: 100%;

  // padding-top: 52px;
  .v-enter {
    transform: translateY(100%);
  }

  .v-enter-to {
    transform: translateY(0%);
  }

  .v-enter-active {
    transition: transform 0.5s;
  }

  /*  .v-leave {
    transform: translateY(0%);
  }

  .v-leave-to {
    transform: translateY(100%);
  }
  .v-leave-active {
    transition: transform 0.5s;
  }*/
}
</style>
<style lang="scss">
// 头部
.headNav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  // background: #b0eac0;
  height: 52px;
  z-index: 10;
  opacity: 0.1;
  pointer-events: none; /* 让其不响应鼠标事件 */
}

.van-toast {
  width: 80%;
  min-width: 80%; /* 设置最小宽度 */
  max-width: 80%; /* 限制最大宽度 */
  padding: 10px 16px; /* 内边距调整 */
  font-size: 32px; /* 设置字体大小 */
  line-height: 1.5; /* 设置行高，避免字体过于拥挤 */
  text-align: center; /* 居中对齐文本 */
  border-radius: 8px; /* 添加圆角 */
}

.van-toast__text {
  white-space: normal; /* 允许文本换行 */
  word-break: break-word; /* 长单词自动换行 */
}


// 地区选择器
.van-ellipsis {
  font-size: 35px;
}

.van-picker__cancel {
  font-size: 35px;
}

.van-picker__confirm {
  font-size: 35px;
}

.overlay {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: #222;
  }

  .block {
    width: 540px;
    // height: 404px;
    background: #ffffff;
    opacity: 1;
    border-radius: 20px;

    .title {
      width: 100%;
      text-align: center;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #000000;
      margin-top: 40px;
    }

    .ipt {
      // width: 100%;
      margin-top: 48px;
      margin-left: 40px;
      width: 460px;
      height: 80px;
      // border: 1px solid #DCE4EB;
      opacity: 1;
      border-radius: 10px;
      padding-left: 20px;

      input {
        width: 100%;
        height: 100%;
        font-size: 32px;
        border: 1px solid #dce4eb;
      }
    }

    .join {
      margin-top: 48px;
      margin-left: 40px;
      width: 460px;
      height: 80px;
      border: 1px solid #dce4eb;
      opacity: 1;
      border-radius: 10px;
      padding-left: 20px;
      display: flex;
      font-size: 34px;
      // align-items: center;
      justify-content: center;
      font-family: Source Han Sans CN;
      font-weight: bold;
    }

    .confirm {
      width: 460px;
      height: 80px;
      background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
      opacity: 1;
      border-radius: 40px;
      margin-left: 41px;
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
    }

    .cancel {
      width: 100%;
      text-align: center;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #909397;
      margin-top: 32px;
      padding-bottom: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue